var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v("Seloca Versandhistorie")]),_c('v-spacer')],1),_c('OrderHistory')],1)}
var staticRenderFns = []

export { render, staticRenderFns }